import React from "react";
import ReporteCtaCteEntidad from "../components/ReporteCtaCteEntidad";

export default function InformeCtaCte() {
  return <ReporteCtaCteEntidad />;
}
